import {
    ADDITIONAL_PAGE_OPTIONS,
    SalesChannel,
    SALESCHANNEL_FAMILY_FRIENDS,
    SALESCHANNEL_REDPLUS,
} from '@vfde-sails/constants';
import { getGigakombiFromSails } from '@vfde-sails/storage';
import { SailsTariffOverviewStorage } from 'Container/App/interface';

/**
 * Get Gigakombi from storage or additional page options
 *
 * The TOP doesn't read the Gigakombi setting from the URL, because switching the gigakombi picker triggers a
 * redirect to a landing page where the correct setting is applied automatically. It still stores the Gigakombi setting
 * in storage though, for use by other applications. Also, if a customer comes from a flow page, and gigakombi is already
 * in their storage, then that setting takes precedence, and the customer will be redirected to the correct page if needed.
 */
export const getGigakombi = (salesChannel: SalesChannel, storage: SailsTariffOverviewStorage | null): boolean => {
    if (salesChannel === SALESCHANNEL_FAMILY_FRIENDS || salesChannel === SALESCHANNEL_REDPLUS) {
        return false;
    }

    // In case the customer came from another page in the flow and has gigakombi true, the storage takes precedence over page config
    return getGigakombiFromStorage(storage) ?? !!window[ADDITIONAL_PAGE_OPTIONS].isGigaKombi;
};

const getGigakombiFromStorage = (storage: SailsTariffOverviewStorage | null): boolean | null => storage && getGigakombiFromSails(storage);
